import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportGrossYieldShekelMarketFetch } from './actions';

export const sagasReportGrossYieldShekelMarket = [
  takeLatest(actionReportGrossYieldShekelMarketFetch.rejected, workerErrorNotifyThunk),
];
